import { createSlice } from '@reduxjs/toolkit'

const defaultState = {
  openToaster: false,
  toasterMessage: '',
  toasterType: 'success'
}

const toaster = createSlice({
  name: 'toaster',
  initialState: defaultState,
  reducers: {
    handleToaster: (state, { payload }) => {
      return {
        ...defaultState,
        ...payload
      }
    }
  }
})

export const { handleToaster } = toaster.actions

export default toaster.reducer
